import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 17 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 32\" id=\"facebook\">\r\n<title>Facebook</title>\r\n<path d=\"M10.844 32v-14.578h4.978l0.712-5.688h-5.69v-3.556c0-1.6 0.534-2.844 2.844-2.844h3.022v-5.156c-0.71 0-2.488-0.178-4.444-0.178-0.136-0.010-0.294-0.015-0.454-0.015-3.79 0-6.862 3.072-6.862 6.862 0 0.218 0.010 0.434 0.030 0.646l-0.002-0.027v4.268h-4.978v5.688h4.978v14.578z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol